<template>
  <div class="panel-body">
    <v-card>
      <v-card-title>{{this.editMessages[0].key}}</v-card-title>
      <template>
        <v-data-table
          :headers="headers"
          :items="editMessages"
          class="elevation-1"
          item-key="key + locale"
          hide-default-footer
        >
          <template v-slot:item.locale="props">
            <v-edit-dialog
              :return-value.sync="props.item.locale"
              @save="save"
              @cancel="revert"
              @open="open"
              @close="close"
            >
              {{ props.item.locale }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.locale"
                  :rules="[max2chars]"
                  label="Edit"
                  single-line
                  counter
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.message="props">
            <v-edit-dialog
              :return-value.sync="props.item.message"
              large
              @save="save"
              @cancel="revert"
              @open="open"
              @close="close"
            >
              {{ props.item.message }}
              <template v-slot:input>
                <v-textarea
                  v-model="props.item.message"
                  :rules="[max512chars]"
                  label="Edit"
                  counter
                  auto-grow
                ></v-textarea>
              </template>
            </v-edit-dialog>
          </template>
        </v-data-table>
      </template>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    </v-card>

  </div>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')
let mh = require('@/components/APIs/MessageHandler')

export default {
  props: {
    messages: {
      required: true
    }
  },
  data: () => ({
    // messages: [],
    dialog: false,
    direction: 'top',
    fab: false,
    fling: true,
    tabs: null,
    transition: 'slide-y-reverse-transition',
    snack: false,
    snackColor: '',
    snackText: '',
    max2chars: v => v.length <= 2 || 'Input too long!',
    max512chars: v => v.length <= 512 || 'Input too long!',
    displayTitle: '',
    valid: true,
    defaultItem: {
      key: '',
      locale: '',
      message: ''
    },
    defaultItems: [
      {
        key: '',
        locale: '',
        message: ''
      }
    ],
    headers: [
      { text: 'Locale', value: 'locale', sortable: true, width: '10%' },
      { text: 'Message', value: 'message' }
    ],

    editMessages: null
  }),

  created () {
    this.initialize()
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    messages: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (!newValue) {
          this.editMessages = JSON.parse(JSON.stringify(this.defaultItem))
        } else {
          this.editMessages = JSON.parse(JSON.stringify(newValue))
        }
        this.setupEdit()
      }
    }
  },
  computed: {},
  methods: {
    initialize () {
      if (!this.messages) { this.editMessages = JSON.parse(JSON.stringify(this.defaultItem)) }
      // this.editCard = this.defaultItem
      // this.editCard = JSON.parse(JSON.stringify(card))
    },
    close () {
      delete this.editMessages
      this.$emit('close-messages')
    },
    async save () {
      if (this.editMessages) {
        // const endpoint = `${process.env.VUE_APP_QUBER_SERVICE_CARDS}/cards`
        // var postResponse = await rh.default.put(endpoint, this.editCard, true).catch(e => {
        //   this.errors.push(e)
        // })
        this.$emit('save-messages', JSON.stringify(postResponse.data))
        // console.log(JSON.stringify(postResponse.data))
        // this.card = JSON.parse(JSON.stringify(this.editCard))
      }
      // console.log(this.editMessages)
    },
    revert () {
      this.editMessages = JSON.parse(JSON.stringify(this.messages))
      this.setupEdit()
    },
    open () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    async setupEdit () {
      if (!this.editMessages) {
        this.editMessages = this.defaultItem
      }
    }
  }
}
</script>
